import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolClientAction } from '../symbolClient.action';

export const endSymbolClientProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolClientAction.update.failed,
    SymbolClientAction.remove.failed,
  ),
  mergeMap(() => {
    return [
      SymbolClientAction.processing.done({}),
    ];
  }),
);
